import { PURCHASE_FEE_PERCENTAGE } from "config/fees";
import { countries } from "config/countries";

import { roundNumber } from "utils/formatter";

class StoreFeeService {
  static getVatRate(countryCode: string | undefined | null): number {
    const country = countryCode
      ? countries.find((country) => country.code === countryCode)
      : null;

    return country?.vatRate ?? 0;
  }

  static getUniqlyFee(
    refPrice: number,
    invoiceCountryCode: string | undefined | null,
  ): number {
    const vatRate = StoreFeeService.getVatRate(invoiceCountryCode);
    const fee = refPrice * (PURCHASE_FEE_PERCENTAGE / 100);

    return PURCHASE_FEE_PERCENTAGE > 0 && vatRate > 0
      ? roundNumber(fee * (1 + vatRate / 100), 2)
      : fee;
  }
}

export default StoreFeeService;
